import { takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import * as pointsActions from './actions';

import { CommandsApi } from 'src/api';
import { apiSagaV2 } from 'src/helpers/saga';

const getPoints = apiSagaV2(pointsActions.getPoints, async (connection, action) => {
  const { siteId, cache } = action.payload;
  return new CommandsApi(connection).getPoints(siteId, cache);
});

const savePoints = apiSagaV2(pointsActions.savePoints, async (connection, action) => {
  const { siteId, points } = action.payload;
  return new CommandsApi(connection).savePoints(siteId, points);
});

export function* pointsSagas() {
  yield takeEvery(getType(pointsActions.getPoints.request), getPoints);
  yield takeEvery(getType(pointsActions.savePoints.request), savePoints);
}
